var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[_c('h3',[_vm._v(_vm._s(_vm.$t('TelaTS.descBo')))]),_c('p',[_vm._v(_vm._s(_vm.$t('TelaTS.descBoSub')))]),_c('img',{attrs:{"width":"1100","src":_vm.boGif,"alt":_vm.desc}})])}
var staticRenderFns = []

export { render, staticRenderFns }